import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("samaaj_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password, user_type = "user") => {
    const { data } = await api.post("/auth/register", { name, email, password, user_type });
    if (data.token) localStorage.setItem("samaaj_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const changeUserType = async (user_type) => {
    const { data } = await api.post("/auth/change-user-type", { user_type });
    setUser((u) => (u ? { ...u, user_type: data.user_type } : u));
    return data.user_type;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (err) { console.error("logout failed", err); }
    localStorage.removeItem("samaaj_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, changeUserType }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
